import React, { useState } from "react";
import { Button, Container, Modal, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import TextInput from "../FormField/TextInput";
import MenuInput from "../FormField/MenuInput";
import { linkExternalResources } from "../../actions/external_resources";
import { toast } from "react-toastify";

function LinkExternalResourcesModal({ showModal, hideModal }) {
  const LINKING = "link";
  const CREATE_AND_LINK = "create_and_link";
  const URL_INVALID = "URL_INVALID";

  const [resourceId, setResourceId] = useState(null);
  const [resourceHref, setResourceHref] = useState("");
  const [resourceName, setResourceName] = useState("");
  const [key, setKey] = useState(LINKING);
  const [error, setError] = useState(false);

  const external_resources_options = useSelector(state => {
    if (state.searchCharacteristics && state.searchCharacteristics.data) {
      return state.searchCharacteristics.data.external_resources;
    } else {
      return [];
    }
  });
  const tree_detail = useSelector(state => state.treeDetail);

  const tree_id = tree_detail.tree_id;
  const external_resources = tree_detail.external_resources;
  const dispatch = useDispatch();

  async function handleResourceLink() {
    dispatch(
      linkExternalResources(tree_id, resourceId, resourceHref, resourceName)
    ).then(response => {
      if (response.status === 200) {
        toast.success("External resource link added!");
        hideModal();
        setKey(LINKING);
        setResourceHref("");
      } else {
        toast.error("Server failed to link external resource");
      }
    });
  }

  return (
    <Modal
      show={showModal}
      onHide={() => {
        hideModal();
        setKey(LINKING);
        setResourceHref("");
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>{"Link External Resource"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextInput
          id="external_resource_href"
          label="Url"
          name="href"
          onChange={(n, v) => {
            try {
              const url = new URL(v);
              let external_resource = external_resources_options.find(
                v => v.url === url.origin
              );
              if (!external_resource) {
                external_resource = external_resources.find(
                  v => v.host === url.origin
                );
              }

              if (external_resource) {
                setResourceId(external_resource.resourceId);
                setKey(LINKING);
                setResourceHref(url.pathname + url.search);
              } else {
                setKey(CREATE_AND_LINK);
                setResourceHref(v);
              }

              setError(false);
            } catch (err) {
              console.log(err);
              setError(URL_INVALID);
            }
          }}
        />

        {error === URL_INVALID && <p style={{ color: "red" }}>URL not valid</p>}

        {key === CREATE_AND_LINK && (
          <p style={{ color: "var(--primary)" }}>
            New resource detected please add a display name
          </p>
        )}

        {key === CREATE_AND_LINK && (
          <TextInput
            id="external_resource_href"
            label="New Resource Name"
            name="name"
            onChange={(n, v) => setResourceName(v)}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="form-button-secondary" onClick={hideModal}>
          Cancel
        </Button>
        <Button
          type="button"
          disabled={error}
          onClick={() => handleResourceLink()}
        >
          Link External Resource
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function ExternalResourcesDisplay(props) {
  const [editMode, setEditMode] = useState(false);
  const [href, setHref] = useState(props.href);
  const tree_id = useSelector(state => state.treeDetail.tree_id);
  const dispatch = useDispatch();

  function edit() {
    return (
      <div
        style={{
          marginTop: "1rem",
          paddingTop: "0.5rem",
          borderTop: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <label className="form-label">
          Host:{" "}
          <span style={{ textTransform: "none", fontWeight: "normal" }}>
            {props.host}
          </span>
        </label>
        <TextInput
          id="external_resource_href"
          label="Href"
          name="href"
          defaultValue={href}
          onChange={(n, v) => {
            setHref(v);
          }}
        />
        <div style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
          <Button
            onClick={() => setEditMode(false)}
            className="form-button-secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              dispatch(
                linkExternalResources(tree_id, props.resourceId, href)
              ).then(response => {
                if (response.status === 200) {
                  toast.success("External Resource Updated!");
                  setEditMode(false);
                } else {
                  toast.error("Server failed to update external resource");
                }
              });
            }}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }

  function info() {
    return <a href={props.host + props.href}>{props.host + props.href}</a>;
  }

  return (
    <div>
      <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
        <h4>{props.name}</h4>

        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            alignItems: "center",
            justifyContent: "end",
            flexGrow: 1,
          }}
        >
          {!editMode && (
            <FaEdit
              size={25}
              className="Icon"
              onClick={() => setEditMode(true)}
            />
          )}
          <FaTrashAlt
            size={25}
            className="Icon"
            onClick={() => {
              dispatch(
                linkExternalResources(tree_id, props.resourceId, "N/A")
              ).then(response => {
                if (response.status === 200) {
                  toast.success("External Resource Unlinked");
                  setEditMode(false);
                } else {
                  toast.error("Failed to unlink resource");
                }
              });
            }}
          />
        </div>
      </div>

      {editMode ? edit() : info()}
    </div>
  );
}

export default function ExternalResources() {
  const treeDetail = useSelector(state => state.treeDetail);
  const [linkModal, setLinkModal] = useState(false);

  const linked_external_resources = treeDetail.external_resources.filter(
    v => !v.href || v.href !== "N/A"
  );

  return (
    <Container
      style={{ display: "flex", gap: "1rem", flexDirection: "column" }}
    >
      <span style={{ display: "flex", gap: "1rem" }}>
        <Button onClick={() => setLinkModal(true)}>
          + Link External Resource
        </Button>
      </span>
      {linked_external_resources.map(v => (
        <div key={v.resourceId}>
          <hr />
          <ExternalResourcesDisplay {...v} />
        </div>
      ))}

      <LinkExternalResourcesModal
        showModal={linkModal}
        hideModal={() => setLinkModal(false)}
      />
    </Container>
  );
}
